// Centralized navigation data. Components must consume from here.
import type { ServiceSlug, SalonSlug } from "./types";

export interface NavItem {
  label: string;
  to: string;
  external?: boolean;
}

export const primaryNav: NavItem[] = [
  { label: "Salonger", to: "/" },
  { label: "Tjänster", to: "/herrklippning" },
  { label: "Produkter", to: "/produkter" },
  { label: "Inspiration", to: "/blogg" },
];

export const footerServiceSlugs: ServiceSlug[] = [
  "herrklippning",
  "skaggtrimning",
  "har-skagg",
  "taper-fade",
  "fade",
  "barnklippning",
  "herrfrisyr",
];

export const footerSalonSlugs: SalonSlug[] = [
  "taby",
  "ahlens-city",
  "akersberga",
  "arninge",
];


export const footerSecondaryNav: NavItem[] = [
  { label: "Inspiration & Guider", to: "/blogg" },
  { label: "Drop-in", to: "/drop-in-barber-stockholm" },
  { label: "English", to: "/en" },
  { label: "Integritetspolicy", to: "/integritetspolicy" },
];

export const ctaLabels = {
  book: "Boka tid",
  bookFallback: "Se pris på BokaDirekt",
  call: "Ring salongen",
  directions: "Vägbeskrivning",
} as const;
